import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Typography, Button } from "antd";
import {
  PictureOutlined,
  BuildOutlined,
  AppstoreAddOutlined,
  SafetyCertificateOutlined,
  InboxOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import NoImage from "../../assets/WechatIMG9.jpg"; // 你自己的背景图
import "./ManufacturingProcess.css";

const { Title } = Typography;

const processes = [
  {
    title: "SENT YOUR DESIGN",
    description: "Send your pictures, 3D files, text or anything you have.",
    link: "/customizedProcess",
    icon: <PictureOutlined />,
    bg: NoImage,
  },
  {
    title: "SAMPLE PRODUCT",
    description: "If you are satisfied with the clay model or 3d product, we will make a corresponding sample.",
    link: "/SampleProduct",
    icon: <BuildOutlined />,
    bg: NoImage,
  },
  {
    title: "MASS PRODUCT",
    description: "After the sample is confirmed, mass product will be produced.",
    link: "/moq",
    icon: <AppstoreAddOutlined />,
    bg: NoImage,
  },
  {
    title: "QUALITY CONTROL",
    description: "Before product is packaged, a quality control process is carried out and any unqualified product will be reworked.",
    link: "/qualityControl",
    icon: <SafetyCertificateOutlined />,
    bg: NoImage,
  },
  {
    title: "PACKING",
    description: "Place the product in the package, pack it in an outer box and wait for shipping.",
    link: "/packing",
    icon: <InboxOutlined />,
    bg: NoImage,
  },
  {
    title: "EXAMPLES",
    description: "Take a look at the examples we have produced.",
    link: "/examples",
    icon: <EyeOutlined />,
    bg: NoImage,
  },
];

const ManufacturingProcess = () => {
  const navigate = useNavigate();

  return (
    <div className="manufacturingContainer">
      <div className="sectionTitle">
        <Title level={2}>Looking for professional stone crafts manufacturers?</Title>
        <div className="titleUnderline" />
      </div>
      <Row gutter={[24, 24]}>
        {processes.map((process, index) => (
          <Col xs={24} sm={12} md={8} key={index}>
            <div className="hoverCard" onClick={() => navigate(process.link)}>
              <div
                className="cardBackground"
                style={{ backgroundImage: `url(${process.bg})` }}
              />
              <div className="iconContainer">{process.icon}</div>
              <div className="textContainer">
                <h3>{process.title}</h3>
                <p>{process.description}</p>
                <Button type="link" className="readMore">
                  Read More
                </Button>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ManufacturingProcess;